// ** Router Import
import Router from "./router/Router";
import React, { useEffect } from "react";
import useBlobity from "blobity/lib/useBlobity";

// import "./@core/assets/fonts/feather/iconfont.css";
// import "./@core/scss/core.scss";
// import "./assets/scss/style.scss";
import { Helmet, HelmetProvider, Parent } from "react-helmet-async";
import Lottie from "lottie-react";

export const initiaBlobityOptions = {
  // licenseKey: 'gmrchk',
  focusableElementsOffsetX: 5,
  focusableElementsOffsetY: 5,
  //color: '#666666',
  color: "#620DF9",
  dotColor: "#620DF9",
  invert: false,
  focusableElements:
    "[data-blobity], a:not([data-no-blobity]), button:not([data-no-blobity]), [data-blobity-tooltip]",
  font: "'Montserrat','Source Sans Pro',-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif",
  fontSize: 14,
  fontWeight: 400,
  opacity: 1,
  zIndex: -1,
  fontColor: "#ffffff",
  size: 40,
  radius: 4,
};

const App = () => {
  const blobityInstance = useBlobity(initiaBlobityOptions);

  useEffect(() => {
    if (blobityInstance.current) {
      // @ts-ignore for debugging purposes or playing around
      window.blobity = blobityInstance.current;
    }
  }, [blobityInstance]);

  return (
    <HelmetProvider>
      <Helmet>
        <meta
          property="og:image"
          content="https://res.cloudinary.com/firejaba/image/upload/v1656781181/Wiply/011_i2ctpw.jpg"
        />
      </Helmet>
      <div 
        onClick={() => {
          const phoneNumber = "+972584729698";
          const message = "i want to learn more about wiply";
          const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
          window.open(whatsappUrl, '_blank');
        }} 
        style={{
          position: "fixed",
          bottom: 0,
          right: 0,
          width: "180px",
          overflow: "hidden",
          zIndex: 999,
          marginRight: "-30px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center"
        }}
      >
        <div style={{
          position: "fixed",
          background: "#B593FF",
          color: "white",
          padding: "8px 12px",
          borderRadius: "20px",
          fontSize: "14px",
          boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
          marginRight: "10px",
          whiteSpace: "nowrap",
          right: "90px"
        }}>
          Need help?
        </div>
        <Lottie
          animationData={require("./S6KZkQ18EV.json")}
          loop={true}
          height={50}
          width={50}
          autoplay={true}
          rendererSettings={{ preserveAspectRatio: "xMidYMid slice" }}
        />
      </div>
      <Router />
    </HelmetProvider>
  );
};

export default App;
